// extracted by mini-css-extract-plugin
module.exports = {"header__cell":"header__cell-f5GwO","header__icon":"header__icon-3ZuiE","title":"title-2ixm-","travelTime":"travelTime-1JY73","fareGroup__logo":"fareGroup__logo-x8SPm"};